import { createSlice } from '@reduxjs/toolkit';
import { fetchSpaUpdateProgress } from '../actions/spaUpdateProgress.actions';
import SpaUpdateProgressState from '../states/spaUpdateProgress.state';

const initialState: SpaUpdateProgressState = {
  loading: false,
  data: [],
  error: null,
  meta: null,
  filters: { stages: [] },
  lastFetched: null,
};

const spaUpdateProgressSlice = createSlice({
  name: 'spaUpdateProgress',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpaUpdateProgress.pending, (state, action) => {
        // A silent (auto-refresh) tick swaps rows in underneath the user rather than
        // tearing the table down to a spinner every few seconds.
        if (!action.meta.arg.silent) state.loading = true;
        state.error = null;
      })
      .addCase(fetchSpaUpdateProgress.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data ?? [];
        state.meta = action.payload.meta ?? null;
        state.filters = action.payload.filters ?? { stages: [] };
        state.lastFetched = action.payload.lastFetched ?? null;
      })
      .addCase(fetchSpaUpdateProgress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      });
  },
});

export default spaUpdateProgressSlice.reducer;
